
import { Component, Vue, Prop } from 'vue-property-decorator'
import { get } from 'lodash'

/**
 * 
 * @prop value 订单列表
 * 
*/

@Component({})
export default class OrderTable extends Vue {
    @Prop({ required: true }) private value!: any[]

    private matchCount(order: any) {
        const unitMap = { 1: '年', 2: '月', report: '次' }
        let unit = get(unitMap, order.product)
        unit = unit || get(unitMap, order.count_type)
        return order.buy_count + unit
    }
}
